import type React from "react";
import { ReactComponent as Svg } from "./assets/icon-betslip.svg";
import * as styles from "./Icon.module.scss";

type BetslipProps = React.SVGProps<SVGSVGElement>;

export const Betslip = ({ className, ...props }: BetslipProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
